import { useState } from 'react';

const AvatarPlaceholder = ({ firstLetter, ...props }) => (
  <div
    className="text-white bg-[#151e34] font-bold w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center text-xs"
    {...props}
  >
    <span>{firstLetter}</span>
  </div>
);

export const ChatAvatar = ({ src, username, ...restProps }) => {
  const [isError, setIsError] = useState(false);

  if (!src || isError) {
    return <AvatarPlaceholder firstLetter={username[0]} />;
  }

  return (
    <img
      className="w-6 h-6 md:w-8 md:h-8 rounded-full"
      src={src}
      onError={() => setIsError(true)}
      {...restProps}
    />
  );
};
